<template>
  <nav v-if="currentPost" class="post-nav" aria-label="Post navigation">
    <a v-if="previousPost" class="post-nav-item previous" :href="previousPost.url">
      <span class="post-nav-label">Previous Post</span>
      <span class="post-nav-title">{{ previousPost.title }}</span>
    </a>
    <span v-else class="post-nav-item post-nav-placeholder"></span>

    <a v-if="nextPost" class="post-nav-item next" :href="nextPost.url">
      <span class="post-nav-label">Next Post</span>
      <span class="post-nav-title">{{ nextPost.title }}</span>
    </a>
    <span v-else class="post-nav-item post-nav-placeholder"></span>
  </nav>
</template>

<script>
import posts from '@/documents/posts.js';

const sortedPosts = posts.slice().sort((a, b) => new Date(a.date) - new Date(b.date));

export default {
  name: 'PostNav',
  computed: {
    currentPath() {
      return this.$route.path.endsWith('/') ? this.$route.path : `${this.$route.path}/`;
    },
    currentIndex() {
      return sortedPosts.findIndex((post) => post.url === this.currentPath);
    },
    currentPost() {
      return sortedPosts[this.currentIndex] || null;
    },
    previousPost() {
      return this.currentIndex > 0 ? sortedPosts[this.currentIndex - 1] : null;
    },
    nextPost() {
      return this.currentIndex >= 0 && this.currentIndex < sortedPosts.length - 1
        ? sortedPosts[this.currentIndex + 1]
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.post-nav {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  max-width: 1000px;
  margin: 0 auto 24px;
  padding: 0 20px;
}

.post-nav-item {
  min-height: 96px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #1f2937;
  text-decoration: none;
}

.post-nav-item:hover {
  border-color: #1697bb;
  color: #1a5881;
}

.post-nav-label {
  display: block;
  margin-bottom: 8px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}

.post-nav-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.next {
  text-align: right;
}

.post-nav-placeholder {
  visibility: hidden;
}

@media (max-width: 768px) {
  .post-nav {
    grid-template-columns: 1fr;
    padding: 0 15px;
  }

  .post-nav-placeholder {
    display: none;
  }

  .next {
    text-align: left;
  }
}
</style>
